// Local dev environment for SOCIETY (societyxpert / portalwiz) theme
// Usage: npm run start:society  |  ng serve --configuration=society
export const environment = {
  production: false,
  theme: 'society' as 'legacy' | 'society' | 'austin' | 'mangalam' | 'relationnest',
  appName: 'SocietyXpert',
  tabTitle: 'SocietyXpert - Simplified Society Management App',
  logoPath: 'assets/Images/societyxpert_logo.png',
  domainUrl: 'https://society-dev.portalwiz.in',
  baseUrl: 'https://society-dev.portalwiz.in/api/public/api',
  storageUrl: 'https://society-dev.portalwiz.in/api/storage/app/',
  enquiryFormUrl: 'https://society-dev.portalwiz.in/php',
};
